import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { PageLayout } from "../src/FunctionalComponents/PageLayout";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import Header from "./FunctionalComponents/Header/Header";
import MyProfile from "./Pages/MyProfile/MyProfile";
import HomePage from "./Pages/HomePage/HomePage";
import NewHomePage from "./Pages/HomePage/NewHomePage";
import IgniteTalks from "./Pages/IgniteTalks/IgniteTalks";
import Admin from "./Pages/Admin/Admin";
import Footer from "./FunctionalComponents/Footer/Footer";

import Team from "Pages/Team/Team";
import { ComingSoon } from "./FunctionalComponents/ComingSoon";
// import LearningHubs from "./Pages/LearningHubs/LearningHubs";
import Testimonials from "./Pages/Testimonials/Testimonials";
// import { Dashboard } from "./FunctionalComponents/Dashboard";
import About from "./Pages/About/About";
import FAQ from "./Pages/FAQ";
import Dashboard from "./Pages/Dashboard";
import LearningHubsNew from "./Pages/LearningHubsNew";
import HallFame from "./Pages/HallFame";
import LearnersReport from "./Pages/Admin/LearnersReport";
import MainPage from "Components/MainPage";
import Iva from "Components/IgniteChat";
import IvaWidget from "Components/IvaWidget";
import Analytics from "FunctionalComponents/Analytics";
import AdminAnalyticsContent from "Pages/Admin/Analytics/AdminAnalytics";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { BASE_API_URL } from "./utils/constants";
import Scoreboard from "FunctionalComponents/Scoreboard/ScoreboardContent";
import UserMaintenance from "Pages/Admin/UserMaintenance";
import QRL from "Pages/QRL/QRL";
import LearnersDetails from "Pages/LearnersDetails/LearnersDetails"

function App({ pca }) {
  // The next 3 lines are optional. This is how you configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in your app
  const history = useHistory();
  const navigationClient = new CustomNavigationClient(history);

  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <PageLayout>
        <div container justifyContent="center">
          <Pages />
        </div>
      </PageLayout>
    </MsalProvider>
  );
}

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const pageMap = {
      "/": "Home",
      "/home": "Home",
      "/learningHubs": "Learning Hubs",
      "/scoreboard": "Scoreboard",
      "/dashboard": "Dashboard",
      "/igniteTalks": "Ignite Talks",
      "/analytics": "Analytics",
      "/team": "Team",
      "/hallOfFame": "Hall of Fame",
      "/aboutIgnite": "About Ignite",
      "/faq": "FAQ",
      "/learnersDetails": "Learners Details"
    };

    const pageName =
      pageMap[location.pathname] ||
      location.pathname.replace("/", "").toUpperCase();

    axios.post(`${BASE_API_URL}/track-page`, {
      enterprise_id: localStorage.getItem("user"),
      page: pageName,
    });
  }, [location.pathname]);

  return null;
};

function Pages() {
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  const activeAccount = accounts[0];

  const [tokenReady, setTokenReady] = useState(false);

  // const fetchAccessToken = async () => {
  // 	if (!activeAccount) return;

  // 	try {
  // 		const response = await instance.acquireTokenSilent({
  // 			...loginRequest,
  // 			account: activeAccount,
  // 		});

  // 		const bearer = `Bearer ${response.accessToken}`;
  // 		localStorage.setItem("token", bearer);
  // 		localStorage.setItem("user", response.account.username);
  // 		localStorage.setItem("name", response.account.name);

  // 		setTokenReady(true); // ✅ important

  // 	} catch (error) {
  // 		console.error("Token error", error);
  // 	}
  // };

  const fetchAccessToken = async () => {
    if (!activeAccount) return;

    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: activeAccount,
      });

      const bearer = `Bearer ${response.accessToken}`;
      localStorage.setItem("token", bearer);
      localStorage.setItem("user", response.account.username);
      localStorage.setItem("name", response.account.name);

      setTokenReady(true);
    } catch (error) {
      console.warn("Silent token failed, fallback to login", error);

      try {
        const response = await instance.acquireTokenRedirect(loginRequest);
        // OR use acquireTokenPopup if you prefer popup
      } catch (err) {
        console.error("Interactive login failed", err);
      }
    }
  };

  useEffect(() => {
    if (activeAccount) {
      fetchAccessToken();
    }
  }, [activeAccount]);

  const [ivaOpen, setIvaOpen] = useState(false);

  if (!tokenReady) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Router basename="/">
        <PageTracker />
        <Header />
        <IvaWidget isOpen={ivaOpen} setIsOpen={setIvaOpen} />
        <Switch>
          <Route exact path="/">
            <NewHomePage openIvaPopup={() => setIvaOpen(true)} />
          </Route>
          <Route exact path="/home">
            <NewHomePage openIvaPopup={() => setIvaOpen(true)} />
          </Route>
          <Route exact path="/learningHubs">
            <LearningHubsNew />
          </Route>
          <Route exact path="/scoreboard">
            <Scoreboard />
          </Route>
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>
          <Route exact path="/igniteTalks">
            <IgniteTalks activeAccount={activeAccount} />
          </Route>
          <Route exact path="/admin">
            <Admin />
          </Route>
          <Route exact path="/analytics">
            <AdminAnalyticsContent />
          </Route>
          <Route exact path="/learnersReport">
            <LearnersReport />
          </Route>
          <Route exact path="/userMaintenance">
            <UserMaintenance />
          </Route>
          <Route exact path="/team">
            <Team />
          </Route>
          <Route exact path="/topLearners">
            <ComingSoon />
          </Route>
          <Route exact path="/hallOfFame">
            <HallFame />
          </Route>
          <Route exact path="/testimonials">
            <Testimonials />
          </Route>
          <Route exact path="/aboutIgnite">
            <About />
          </Route>
          <Route exact path="/faq">
            <FAQ />
          </Route>
          <Route exact path="/prompttest">
            <MainPage />
          </Route>
          <Route exact path="/iva">
            <Iva />
          </Route>
          <Route exact path="/qrl">
            <QRL />
          </Route>
          <Route exact path="/learnersDetails">
            <LearnersDetails />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </>
  );
}

export default App;
